import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { GlobalState } from "@/Reducers/interface";
import { BillingInfo } from "@/Contracts/Users";
import useDispatch from "@/Components/Utils/useDispatch";
import UsersActionCreators from "@/Actions/User";

import PersonImg from "@/Assets/Others/PaymentModal/PersonImg.svg";
import FlowersImg from "@/Assets/Others/PaymentModal/FlowersImg.svg";

import "./OnBoardingModal.less";

const OnBoardingModal = () => {
	const dispatch = useDispatch();

	const { user, isLoggedIn } = useSelector((state: GlobalState) => ({
		user: state.user,
		isLoggedIn: state.login.isLoggedIn
	}));

	const [isOnboardingCallScheduled, setIsOnboardingCallScheduled] =
		useState<boolean>(false);

	const calendlyListener = async (event: any) => {
		if (
			event.data.event &&
			event.data.event.indexOf("calendly") === 0 &&
			event.data.event === "calendly.event_scheduled"
		) {
			try {
				await dispatch(UsersActionCreators.onboardingCallScheduled());
				removeCalendlyIframe();
			} catch (error) {
				console.error(error);
			}
		}
	};

	const removeCalendlyIframe = () => {
		const calendly = document.querySelector(
			"script#calendly-widget"
		) as HTMLScriptElement;
		calendly?.parentElement?.removeChild(calendly);
		window.removeEventListener("message", calendlyListener);
	};

	const getBillingInfo = async () => {
		try {
			await dispatch(UsersActionCreators.getBillingInfo());
		} catch (error) {
			console.error(error);
		}
	};

	let firstRender = false;

	useEffect(() => {
		if (isLoggedIn && !user.billingInfo) {
			getBillingInfo();
		}
	}, [isLoggedIn, user.billingInfo]);

	useEffect(() => {
		if (!firstRender) {
			firstRender = true;
			// const shouldOnBoardUser = BillingInfo.isOnboarded(user.billingInfo);
			// setShouldOnBoard(shouldOnBoardUser);
			// if (shouldOnBoard || shouldOnBoardUser) {
			// 	initializeCalendy();
			// 	window.addEventListener('message', calendlyListener);
			// }
		}
		setIsOnboardingCallScheduled(
			BillingInfo.isOnboardingCallScheduled(user.billingInfo)
		);
		return () => {
			removeCalendlyIframe();
		};
	}, [isLoggedIn, isOnboardingCallScheduled, user]);

	return (
		<Modal
			closable={false}
			visible={isOnboardingCallScheduled}
			footer={null}
			width={925}
			centered
			className={`onboarding-modal`}
			bodyStyle={{
				borderRadius: "0px",
				background: "#ffffff",
				padding: "0px"
			}}
			zIndex={999999999} // this is to override user pilot iframe zIndex
		>
			{isOnboardingCallScheduled ? (
				<div className="onboarding-info_container">
					<div className="left-side-container">
						<div className="heading">
							Welcome to Zomentum - Don't Just Make a Sale, Make a
							Difference
						</div>
						<div className="break-line" />
						Welcome!
						<div className="break-line" /> As the Founder and CEO of
						Zomentum, I want to officially welcome you to the
						Zomentum family! You are now a part of an active and
						growing sales movement that is empowering MSPs to
						streamline their go-to-market capabilities.{" "}
						<div className="break-line" /> In a short amount of
						time, we have seen partners who use our platform go from
						17% to 37% conversions on their quotes and can get
						proposals out the door in a median time of 22 minutes.{" "}
						<div className="break-line" />
						Congratulations on taking the first necessary step to
						intentionally growing your business! The entire Customer
						Success team at Zomentum stands ready to take you
						through the onboarding experience. Honestly, we are
						pretty excited about it. In our first onboarding call we
						will cover: <div className="break-line" />
						<ul>
							<li>
								Understanding your goals and why you chose
								Zomentum
							</li>
							<li>Discuss your current workflow</li>
							<li>Account activation and basic setup</li>
							<li>Integration and data requests</li>
						</ul>
						Let's do this.
						<div className="break-line" />
						Sincerely, <br />
						Shruti
					</div>
					<div className="right-side-container">
						Please note we have restricted access to the platform
						until your first onboarding session. We will NOT start
						your 14-day trial until your first onboarding session is
						completed.
						<div className="break-line" /> We've found that partners
						who engage with one of our Customer Success Managers
						from the beginning are able to get up and running faster
						and have a better overall experience.{" "}
						<div className="break-line" /> If you have to reschedule
						your onboarding appointment for any reason, please let
						us know.
						<div className="images">
							<FlowersImg className="flowers-img" />
							<PersonImg className="person-img" />
						</div>
					</div>
				</div>
			) : null}
		</Modal>
	);
};

export default OnBoardingModal;
